import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { REACT_APP_SKIP_LOGIN } from '../../config';
import { hasAppQueryParams, logToRemote } from '../../util';
import ErrorPage from '../ErrorPage';
import { ConsentError } from '../../constants';

const Login = ({ login, error, account }) => {
  const hasParams = hasAppQueryParams();

  useEffect(() => {
    if (!error && !REACT_APP_SKIP_LOGIN && hasParams) {
      login();
    } else {
      console.log(`Login error ${error}`);
    }
  }, [account, error, login, hasParams]);

  if (!hasParams) {
    const errorParams = {
      code: 400,
      level: 'error',
      src: 'Login/index.js::!hasParams',
      desc: 'App was invoked with no initial query params',
      status: 'error',
      moreInfo: `consent.error.${ConsentError.missingQueryParams}`,
    };
    logToRemote(errorParams);
    return <ErrorPage {...errorParams} />;
  }

  return (
    <div className='loading-spinner'>
      <div className='spinner'></div>
    </div>
  );
};

Login.propTypes = {
  login: PropTypes.func.isRequired,
  error: PropTypes.object,
  account: PropTypes.object,
};

export default Login;
